const inventoryAr = {
    brand: require('../../lang/ar/inventory/Brand').default,
    color: require('../../lang/ar/inventory/Color').default,
    deliveryNote: require('../../lang/ar/inventory/DeliveryNote').default,
    invoice: require('../../lang/ar/inventory/Invoice').default,
    item: require('../../lang/ar/inventory/Item').default,
    measureUnit: require('../../lang/ar/inventory/MeasureUnit').default,
    measureUnitType: require('../../lang/ar/inventory/MeasureUnitType').default,
    payment: require('../../lang/ar/inventory/Payment').default,
    pricingMaster: require('../../lang/ar/inventory/PricingMaster').default,
    rack: require('../../lang/ar/inventory/Rack').default,
    segment: require('../../lang/ar/inventory/Segment').default,
    subCategory: require('../../lang/ar/inventory/SubCategory').default,
};

export default inventoryAr;